"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const video_client_core_1 = require("@video/video-client-core");
const mobx_react_lite_1 = require("mobx-react-lite");
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("../../../context");
const PeerMuted_1 = tslib_1.__importDefault(require("../../../ui-lib/Badges/PeerMuted"));
const ErrorBoundary_1 = require("../../ErrorBoundary");
const ModularPeerMutedBadge = (0, mobx_react_lite_1.observer)(({ icon, muted, ...props }) => {
    var _a;
    /**
     * Component Name (for error msg)
     */
    const componentName = "<PeerMutedBadge/>";
    /**
     * Access PlayerUiContext.
     */
    const ctx = (0, react_1.useContext)(context_1.PlayerUiContext);
    (0, ErrorBoundary_1.useUndefinedStoreError)(ctx != null, componentName);
    return ctx.player.isImplements(video_client_core_1.player.Feature.CONSUMER) ? (react_1.default.createElement(PeerMuted_1.default, { muted: (_a = muted !== null && muted !== void 0 ? muted : !ctx.player.consumerAudioEnabled) !== null && _a !== void 0 ? _a : false, icon: icon, ...props })) : null;
});
// eslint-disable-next-line react/function-component-definition
const PeerMutedBadgeWithErrorBoundary = ({ ...props }) => {
    return (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { render: () => null },
        react_1.default.createElement(ModularPeerMutedBadge, { ...props })));
};
exports.default = PeerMutedBadgeWithErrorBoundary;
//# sourceMappingURL=PeerMuted.js.map